import { WithContext, FAQPage } from 'schema-dts';

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSchemaProps {
  faqs: FAQItem[];
  url?: string;
}

/**
 * Generates Schema.org FAQPage structured data
 * Helps search engines display FAQ content in rich snippets
 * Provides context for AI models answering questions about Flexibooking
 */
export function generateFAQSchema({
  faqs,
  url = 'https://www.flexibooking.sk/faq',
}: FAQSchemaProps): WithContext<FAQPage> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
    url,
    inLanguage: 'sk',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Flexibooking',
      url: 'https://www.flexibooking.sk',
    },
  };
}
